/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {EPartsTypes, RenderElement} from "App/model/elements/element";
import Description from "App/model/description";
import PartsEntity from "App/model/parts/parts_entity";
import {isPointingToOrigin, isRelative} from "App/storage/utils";

export default
class GeometryEntityElement extends RenderElement {

    public static TypeName: string = "GeometryEntity";

    constructor(aModelDescription: Description)
    {
        super(aModelDescription);
    }

    public static create(aModelDescription: Description, aUID: number)
    {
        let obj = new GeometryEntityElement(aModelDescription);
        obj._typeName = GeometryEntityElement.TypeName;
        obj._UID = aUID;
        return obj;
    }

    public parse(aElementDescriptionJSON: any)
    {
        let ret = super.parse(aElementDescriptionJSON);
        if (!ret) {
            return false;
        }

        // parse the entities
        let type = EPartsTypes.entities;
        if (aElementDescriptionJSON.hasOwnProperty(type)) {
            this._parsedParts[type] = new PartsEntity();
            this._parsedParts[type].setValues(aElementDescriptionJSON[type]);
            this._parsedParts[type].setParsedShapesIDToElementMapping(this);

            let values = this._parsedParts[type]._values;
            for (let entity of values) {
                if (entity.hasOwnProperty("images")) {
                    for (let image of entity.images) {
                        if (isRelative(image.url)) {
                            // relative path so prefi it with model
                            image.url = this._modelDescription.getRenderModel().getBaseUrl() + image.url.replace(/\\/g, "/");
                        }
                        else if (isPointingToOrigin(image.url)) {
                            image.url = window.location.origin + image.url;
                        }
                    }
                }
            }
        }
    }
}
